import { FC, useEffect, useState } from 'react'
import { jwtDecode } from "jwt-decode";
import { UserType } from '../../../../../app/models/UserType';

const HeaderUserMenu: FC = () => {
  const token = localStorage.getItem("token");

  const [nameSurname, setNameSurname] = useState('');
  const [title, setTitle] = useState('');
  const [company, setCompany] = useState('');
  const [mail, setMail] = useState('');
  
  useEffect(() => {
    if (token === null) {
      return;
    }
    const userToken = jwtDecode(token) as UserType;
    setNameSurname(userToken.name ?? "-");
    setTitle(userToken.label ?? "-");
    setCompany(userToken.company ?? "-");
    setMail(userToken.email ?? "-");
  }, [token]);
  
  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
      data-kt-menu='true'>
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='d-flex flex-column'>
            <div className='fw-bolder d-flex align-items-center fs-5'>
              {nameSurname}
            </div>
            <label className='fw-bold'>
              {title}
            </label>
            <div className='fw-bolder d-flex align-items-center fs-5'>
              <label className='fw-bold'>
                {company}
              </label>
            </div>
          </div>
        </div>
      </div>

      <div className='separator my-2'></div>
      <div className='px-5 mb-3'>
        <label>
          Email :
        </label>
        <label className='px-2'>
          {mail}
        </label>
      </div>
    </div>
  )
}

export { HeaderUserMenu }



